import { useDispatch as libUseDispatch } from 'react-redux'
import { Dispatch } from 'utilities/types'

const useDispatch: () => Dispatch = libUseDispatch

export default useDispatch
